export type IFlyersTabBrandsItemResources = typeof FlyersTabBrandsItemResources;

export const FlyersTabBrandsItemResources = {
    newFlyerText: "Nowa Gazetka",
};
